import React from "react";
import { Card, Tab, Tabs, CardContent } from "@material-ui/core";
import PropertyDetails from "./update-container";
import PropertyUseCases from "./use-cases";


interface Props {
  path: string;
  id?: string;
}

enum TabsIndex {
  Details = 0,
  UseCases = 1
}

const UpdateInterestListPage: React.FC<Props> = ({ id: propertyId }) => {
  const [tabIndex, setTabIndex] = React.useState<TabsIndex>(0);
  if (!propertyId) return <div>Invalid URL</div>;
  return (
    <>
      <Tabs
        value={tabIndex} onChange={(_: any, index: TabsIndex) => setTabIndex(index)}>
        <Tab label="Details" />
        <Tab label="Use Cases" />
      </Tabs>

      <Card>
        <CardContent>
          {tabIndex === TabsIndex.Details && (
            <PropertyDetails propertyId={propertyId} />)}
          {tabIndex === TabsIndex.UseCases && (
            <PropertyUseCases propertyId={propertyId} />)}
        </CardContent>
      </Card>
    </>
  );
};

export default UpdateInterestListPage;
